module.exports = __webpack_public_path__ + "img/cert5.738a42a2.png";